<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>
  <app-product-edit-dialog
    [products]="data"
    (addProduct)="addProduct($event)"
    (updateProduct)="updateProduct($event)"
  ></app-product-edit-dialog>
  <app-action-grid
    [data]="data"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    [actionButtons]="actionButtons"
    (actionCommit)="actionCommit($event)"
  ></app-action-grid>
</app-main-contents>
